/**
 * KEMI PARIS — UTM / click-id forwarding across the lander hop.
 *
 * Landers are the paid destination in the LP-vs-PDP split test, but the buy CTA
 * sends the reader to /products/... on the same origin, which drops the campaign
 * params. Without this, the LP arm has no attribution.
 *
 * Delegated at the document level ON PURPOSE: CTAs are added by sections and by
 * the theme editor after load, so per-anchor binding would silently miss them.
 * Marked-up anchors opt in with data-utm-forward.
 */
(function () {
  const FORWARD = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'fbclid',
    'ttclid',
    'gclid',
    'wbraid',
    'gbraid',
  ];

  let carried = null;

  function params() {
    if (carried) return carried;
    const here = new URLSearchParams(window.location.search);
    carried = new URLSearchParams();
    FORWARD.forEach((k) => {
      const v = here.get(k);
      if (v) carried.set(k, v);
    });
    // Survive an internal hop that itself had no params (lander -> PDP -> cart).
    if (![...carried].length) {
      try {
        const stashed = sessionStorage.getItem('kemi:utm');
        if (stashed) carried = new URLSearchParams(stashed);
      } catch (e) {
        /* private mode */
      }
    } else {
      try {
        sessionStorage.setItem('kemi:utm', carried.toString());
      } catch (e) {
        /* private mode */
      }
    }
    return carried;
  }

  function decorate(anchor) {
    const carry = params();
    if (![...carry].length) return;

    let url;
    try {
      url = new URL(anchor.getAttribute('href'), window.location.origin);
    } catch (e) {
      return;
    }
    // Same-origin only. Never leak campaign params to a third party.
    if (url.origin !== window.location.origin) return;

    carry.forEach((v, k) => {
      if (!url.searchParams.has(k)) url.searchParams.set(k, v);
    });
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  }

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target.closest?.('a[data-utm-forward][href]');
      if (!anchor) return;
      decorate(anchor);
    },
    { capture: true }
  );

  // Middle-click and keyboard activation don't fire a plain click first.
  document.addEventListener(
    'auxclick',
    (event) => {
      const anchor = event.target.closest?.('a[data-utm-forward][href]');
      if (anchor) decorate(anchor);
    },
    { capture: true }
  );
})();
